// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBxT9ugeNMEds2BznSnVUaZo9zB_0_LVx0",
    authDomain: "simple-firebase-recap-ed1dd.firebaseapp.com",
    projectId: "simple-firebase-recap-ed1dd",
    storageBucket: "simple-firebase-recap-ed1dd.appspot.com",
    messagingSenderId: "247351717940",
    appId: "1:247351717940:web:1e9a7e685a0c3262acda61"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;